// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ConfirmationModal_modalFooter__39QV1","modalWrapper":"ConfirmationModal_modalWrapper__2-n_C","buttonContainer":"ConfirmationModal_buttonContainer__2T0bH"};